import type { InputHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode;
  optionnel?: string | undefined;
  aide?: ReactNode;
  erreur?: string | undefined;
}

/** Champ de formulaire : vrai `<label>`, aide, message d'erreur relié par aria-describedby. */
export const Champ = forwardRef<HTMLInputElement, Props>(function Champ({ label, optionnel, aide, erreur, id, ...input }, ref) {
  const idAide = aide ? `${id}-aide` : undefined;
  const idErreur = erreur ? `${id}-erreur` : undefined;
  return (
    <div className="pile-6">
      <label className="f-label" htmlFor={id}>
        {label}
        {optionnel ? <span className="optionnel"> ({optionnel})</span> : null}
      </label>
      <input ref={ref} id={id} className="f-input" aria-invalid={erreur ? 'true' : undefined} aria-describedby={[idErreur, idAide].filter(Boolean).join(' ') || undefined} {...input} />
      {erreur ? (
        <span id={idErreur} className="f-erreur" role="alert">
          {erreur}
        </span>
      ) : null}
      {aide ? (
        <span id={idAide} className="f-hint">
          {aide}
        </span>
      ) : null}
    </div>
  );
});
